import { employmentTypeSchema, gigTypeSchema } from "api/resources/shared";
import * as z from "zod/mini";

// Shared by AdminGigs and, once converted, the schedule GigBoard admin filters.
export const gigFilterSchema = z.object({
  ordering: z.optional(z.string()),
  require_certifications: z.optional(z.boolean()),
  elevated: z.optional(z.boolean()),
  auto_select_enabled: z.optional(z.boolean()),
  location_name: z.optional(z.string()),
  market_name: z.optional(z.string()),
  skill_id: z.optional(z.number()),
  pro_id: z.optional(z.number()),
  pro_first_name: z.optional(z.string()),
  pro_last_name: z.optional(z.string()),
  start_time__gte: z.optional(z.coerce.date()),
  start_time__lte: z.optional(z.coerce.date()),
  end_time__gte: z.optional(z.coerce.date()),
  end_time__lte: z.optional(z.coerce.date()),
  employment_type: z.optional(employmentTypeSchema),
  type: z.optional(gigTypeSchema),
  gig_id: z.optional(z.number()),
});
